webpackJsonp([258170291986048],{

/***/ 383:
/***/ (function(module, exports) {

	module.exports = {"reasons":[{"loan":"A loan requires the end user to invest a down payment in the equipment. The loan finances the remaining amount.","lease":"A lease requires no down payment and finances only the value of the equipment expected to be depleted during the lease term. The lessee usually has an option to buy the equipment for its remaining value at lease end."},{"loan":"A loan usually requires the borrower to pledge other assets for collateral.","lease":"The leased equipment itself is usually all that is needed to secure a lease transaction."},{"loan":"A loan usually requires two expenditures during the first payment period; a down payment at the beginning and a loan payment at the end.","lease":"A lease requires only a lease payment at the beginning of the first payment period which is usually much lower than the down payment."},{"loan":"The end user bears all the risk of equipment devaluation because of new technology.","lease":"The end user transfers all risk of obsolescence to the lessors as there is no obligations to own equipment at the end of the lease."},{"loan":"End users may claim tax deduction for a potion of the loan payment as interest and for depreciation which is tied to IRS depreciation schedules.","lease":"When leases are structured as true leases, the end user may claim the entire lease payment as a tax deduction. The equipment write-off is tied to the lease term, which can be shorter than IRS depreciation schedules, resulting in larger tax deductions each year. The deduction is also the same every year, which simplifies budgeting (equipment financed with a conditional sale lease is treated the same as owned equipment)."},{"loan":"Financial Accounting Standards require owned equipment to appear as an asset with a corresponding liability on the balance sheet.","lease":"Leased assets are expensed when the lease is an operating lease. Such assets do not appear on the balance sheet, which can improve financial ratios."},{"loan":"A larger portion of the financial obligation is paid in today's more expensive dollars.","lease":"More of the cash flow, especially the option to purchase the equipment, occurs later in the lease term when inflation makes dollars cheaper."}]}

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sideNav = __webpack_require__(10);
	
	var _sideNav2 = _interopRequireDefault(_sideNav);
	
	var _leaseLoan = __webpack_require__(383);
	
	__webpack_require__(292);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var components = ['why', 'press', 'history', 'questions', 'case-study', 'lease-loan', 'good-business'];
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'lease-hero' },
	      _react2.default.createElement('div', { className: 'lease-hero-img' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'lease-title' },
	      'Lease vs Loan'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'lease-content' },
	      _react2.default.createElement(_sideNav2.default, { components: components, base: 'why', current: 'lease-loan' }),
	      _leaseLoan.reasons.map(function (reason, i) {
	        return _react2.default.createElement(
	          'p',
	          { key: i, className: 'reason' },
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Loan:'
	          ),
	          ' ',
	          reason.loan,
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Lease:'
	          ),
	          ' ',
	          reason.lease
	        );
	      })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 292:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-why-lease-loan-js-fbf5512cf95033b3d151.js